import * as z from "zod";
//#region src/__generated__/files/external/zod/deleteFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteFileMetasRequestDtoSchema = z.object({
	initUserId: z.uuid(),
	ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" })
});
//#endregion
//#region src/__generated__/files/external/zod/deleteMany1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteMany1Status200Schema = z.array(z.string());
const deleteMany1ResponseSchema = deleteMany1Status200Schema;
const deleteMany1DataSchema = deleteFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/files/external/zod/getCheckSum1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getCheckSum1PathFileIdSchema = z.uuid();
const getCheckSum1Status200Schema = z.string();
const getCheckSum1ResponseSchema = getCheckSum1Status200Schema;
//#endregion
//#region src/__generated__/files/external/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid().nullish(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"EKPTD_RESOURCE",
		"EKPTD_ROLE_APPLICATION",
		"EKPTD_REJECT_ROLE_APPLICATION",
		"EKPTD_REVOKE_ROLE_APPLICATION",
		"LIBRARY",
		"KNOWLEDGE_BASE",
		"EXTERNAL_REQUEST",
		"INTERNAL_REQUEST",
		"INTERNAL_REQUEST_SUPPORTING",
		"INTERNAL_REQUEST_TU_PART",
		"INTERNAL_REQUEST_FINAL_DECISION"
	]),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1"),
	version: z.int(),
	baseName: z.string(),
	size: z.int(),
	ext: z.string().nullish(),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"ROLE_APPLICATION",
		"RESOURCE_DOCUMENT",
		"LIBRARY_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REQUEST_DOCUMENT",
		"SUPPORTING_DOCUMENT"
	]),
	createdAt: z.iso.datetime(),
	modifiedAt: z.iso.datetime(),
	isDeleted: z.boolean(),
	isBlocked: z.boolean(),
	previewId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	author: z.uuid(),
	hash: z.string().nullish()
});
//#endregion
//#region src/__generated__/files/external/zod/getFileMeta1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMeta1PathFileIdSchema = z.uuid();
const getFileMeta1Status200Schema = fileMetaDtoSchema;
const getFileMeta1ResponseSchema = getFileMeta1Status200Schema;
//#endregion
//#region src/__generated__/files/external/zod/getFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/files/external/zod/getFileMetas1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetas1Status200Schema = z.array(fileMetaDtoSchema);
const getFileMetas1ResponseSchema = getFileMetas1Status200Schema;
const getFileMetas1DataSchema = getFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/files/external/zod/getLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/files/external/zod/getLatestFileMetas1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetas1Status200Schema = z.array(fileMetaDtoSchema);
const getLatestFileMetas1ResponseSchema = getLatestFileMetas1Status200Schema;
const getLatestFileMetas1DataSchema = getLatestFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/files/external/zod/requestListRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestListRequestSchema = z.object({ id: z.uuid() });
//#endregion
//#region src/__generated__/files/external/zod/requestListResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestListResponseSchema = z.object({ fileMeta: fileMetaDtoSchema.nullish() });
//#endregion
//#region src/__generated__/files/external/zod/list1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const list1Status200Schema = z.array(requestListResponseSchema);
const list1ResponseSchema = list1Status200Schema;
const list1DataSchema = requestListRequestSchema;
//#endregion
//#region src/__generated__/files/external/zod/requestMoveRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestMoveRequestSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid(),
	userId: z.uuid()
});
//#endregion
//#region src/__generated__/files/external/zod/requestMoveResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestMoveResponseSchema = z.object({ moveCnt: z.int().nullish() });
//#endregion
//#region src/__generated__/files/external/zod/move1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const move1Status200Schema = z.array(requestMoveResponseSchema);
const move1ResponseSchema = move1Status200Schema;
const move1DataSchema = requestMoveRequestSchema;
//#endregion
//#region src/__generated__/files/external/zod/requestRenameRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestRenameRequestSchema = z.object({
	id: z.uuid(),
	newName: z.string().min(1),
	userId: z.uuid()
});
//#endregion
//#region src/__generated__/files/external/zod/requestRenameResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const requestRenameResponseSchema = z.object({ fileMeta: fileMetaDtoSchema.nullish() });
//#endregion
//#region src/__generated__/files/external/zod/rename1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const rename1Status200Schema = requestRenameResponseSchema;
const rename1ResponseSchema = rename1Status200Schema;
const rename1DataSchema = requestRenameRequestSchema;
//#endregion
//#region src/__generated__/files/external/zod/resolveLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).min(1).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/files/external/zod/resolveLatestFileMetas1Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetas1Status200Schema = z.array(fileMetaDtoSchema);
const resolveLatestFileMetas1ResponseSchema = resolveLatestFileMetas1Status200Schema;
const resolveLatestFileMetas1DataSchema = resolveLatestFileMetasRequestDtoSchema;
//#endregion
export { getFileMeta1Status200Schema as A, getLatestFileMetasRequestDtoSchema as C, getFileMetasRequestDtoSchema as D, getFileMetas1Status200Schema as E, deleteMany1DataSchema as F, deleteMany1ResponseSchema as I, deleteMany1Status200Schema as L, getCheckSum1PathFileIdSchema as M, getCheckSum1ResponseSchema as N, getFileMeta1PathFileIdSchema as O, getCheckSum1Status200Schema as P, deleteFileMetasRequestDtoSchema as R, getLatestFileMetas1Status200Schema as S, getFileMetas1ResponseSchema as T, list1Status200Schema as _, rename1DataSchema as a, getLatestFileMetas1DataSchema as b, requestRenameResponseSchema as c, move1ResponseSchema as d, move1Status200Schema as f, list1ResponseSchema as g, list1DataSchema as h, resolveLatestFileMetasRequestDtoSchema as i, fileMetaDtoSchema as j, getFileMeta1ResponseSchema as k, requestRenameRequestSchema as l, requestMoveRequestSchema as m, resolveLatestFileMetas1ResponseSchema as n, rename1ResponseSchema as o, requestMoveResponseSchema as p, resolveLatestFileMetas1Status200Schema as r, rename1Status200Schema as s, resolveLatestFileMetas1DataSchema as t, move1DataSchema as u, requestListResponseSchema as v, getFileMetas1DataSchema as w, getLatestFileMetas1ResponseSchema as x, requestListRequestSchema as y };

//# sourceMappingURL=resolveLatestFileMetas1Schema.js.map